import { css } from '@emotion/react'
import { Button, ButtonProps, HFlow, Text, Theme, Tooltip, useTheme } from 'bold-ui'
import { ColorScale } from 'bold-ui/lib/styles/colors'
import { useMemo } from 'react'

interface IconLabelButtonProps extends Omit<ButtonProps, 'style'> {
  isActive?: boolean
  img: string
  title: string
  mainColor?: ColorScale
  alt: string
  tooltipText?: string
  handleClick?(): void
}

export function IconLabelButton(props: IconLabelButtonProps) {
  const theme = useTheme()
  const { isActive, img, title, mainColor, alt, handleClick, tooltipText, ...rest } = props

  const styles = useMemo(() => createStyles(theme, isActive, mainColor), [isActive, theme, mainColor])
  return (
    <Tooltip text={tooltipText}>
      <Button size='medium' style={styles.button} onClick={handleClick} {...rest}>
        <HFlow alignItems='center' hSpacing={0.5}>
          <img css={styles.icon} src={img} alt={alt} />
          <Text fontWeight='bold' style={styles.buttonText}>
            {title}
          </Text>
        </HFlow>
      </Button>
    </Tooltip>
  )
}

const createStyles = (theme: Theme, isActive: boolean, mainColor?: ColorScale) => {
  return {
    button: css`
      width: 9.75rem;
      justify-content: flex-start;
      border: ${isActive ? '0' : `1px ${mainColor.c60} solid`};
      background-color: ${isActive ? mainColor.c60 : theme.pallete.gray.c100};
      margin: 0;
      &:not(:disabled):hover {
        background-color: ${isActive ? mainColor.c50 : mainColor.c90};
      }
    `,
    buttonText: css`
      color: ${isActive ? theme.pallete.gray.c100 : mainColor.c40};
    `,
    icon: css`
      width: 2.25rem;
    `,
  }
}
